import { render, staticRenderFns } from "./QuestionInterpretation.vue?vue&type=template&id=5039aa79&scoped=true"
import script from "./QuestionInterpretation.vue?vue&type=script&lang=js"
export * from "./QuestionInterpretation.vue?vue&type=script&lang=js"
import style0 from "./QuestionInterpretation.vue?vue&type=style&index=0&id=5039aa79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039aa79",
  null
  
)

export default component.exports